module.exports = __webpack_public_path__ + "img/2012.a2eb42c1.jpg";